import { MapComponent } from '../components/MapComponent';
import { Route } from '../components/Route';
import {z} from 'zod';

const RouteSchema = z.object({
  id: z.string(),
  filename: z.string(),
  progress: z.number().min(0).max(1).multipleOf(0.01),
  animated: z.boolean(),
  hidden: z.boolean(),
});

export const EnrouteSchema = z.object({
  visited_countries: z.array(z.string()),
  routes: z.array(RouteSchema),
  animatedDistance: z.number().min(0).max(1),
});

export const EnRouteComposition: React.FC<z.infer<typeof EnrouteSchema>> = ({visited_countries, routes, animatedDistance}) => {
  return <MapComponent highlighted_countries={visited_countries}>
    {routes.filter(r => !r.hidden).map(route => {
      return <Route key={route.id} id={route.id} geoJSONFile={route.filename} position={route.progress} animated={route.animated} animatedDistance={animatedDistance}/>
    })}
  </MapComponent>
};